import { apiClient } from './client'

export type ProductionEditingAccess = {
  canEdit: boolean
  isOwner: boolean
  isProduction: boolean
  currentEnvironment: string
  message: string
}

export const getProductionEditingAccess = async () => {
  const { data } = await apiClient.get<ProductionEditingAccess>('/api/admin/production-edit-access')
  return data
}
